import React from 'react';

type QueryWrapperProps<T> = {
  isLoading: boolean;
  error: Error | null;
  data: T | undefined;
  children: (data: T) => React.ReactNode;
  LoadingComponent?: React.ComponentType;
  ErrorComponent?: React.ComponentType<{ message: string }>;
  NotFoundComponent?: React.ComponentType;
};

const DefaultLoadingComponent: React.ComponentType = () => (
  <div>Loading...</div>
);

const DefaultErrorComponent: React.ComponentType<{ message: string }> = ({
  message,
}) => <div>Error {message}</div>;

const DefaultNotFoundComponent: React.ComponentType = () => (
  <div>Not found</div>
);

export const QueryWrapper = <T,>({
  isLoading,
  error,
  data,
  children,
  LoadingComponent = DefaultLoadingComponent,
  ErrorComponent = DefaultErrorComponent,
  NotFoundComponent = DefaultNotFoundComponent,
}: QueryWrapperProps<T>) => {
  if (isLoading) {
    return <LoadingComponent />;
  }
  if (error) {
    return <ErrorComponent message={error.message} />;
  }
  if (!data) {
    return <NotFoundComponent />;
  }
  return <>{children(data)}</>;
};